import { DollarSign, TrendingUp, ShoppingCart, Users } from 'lucide-react';
import WidgetShell from '../WidgetShell';
import StatCard from '../StatCard';
import { useEcomStats } from '@/hooks/dashboard/useEcomDashboard';
import { formatCurrency } from '@/lib/utils';

/**
 * Revenue at a glance (today / this week / this month) + new customers.
 * Trend deltas are intentionally omitted — the backend hardcodes them to 0
 * (functions/src/routes/admin/dashboard.ts), so a "+0.0%" would mislead.
 */
export default function RevenueKpisWidget() {
  const { data, isLoading, error } = useEcomStats();

  return (
    <WidgetShell
      title="Revenue"
      icon={<DollarSign />}
      to="/admin/orders"
      isLoading={isLoading}
      error={error}
      skeletonClassName="h-24"
    >
      {data && (
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
          <StatCard
            title="Today"
            value={formatCurrency(data.revenue_today)}
            icon={<DollarSign />}
            tone="green"
          />
          <StatCard
            title="This Week"
            value={formatCurrency(data.revenue_week)}
            icon={<TrendingUp />}
            tone="blue"
          />
          <StatCard
            title="This Month"
            value={formatCurrency(data.revenue_month)}
            icon={<ShoppingCart />}
            tone="purple"
          />
          <StatCard
            title="New Customers"
            value={data.new_customers_month}
            subtitle="This month"
            icon={<Users />}
            tone="orange"
          />
        </div>
      )}
    </WidgetShell>
  );
}
